export default __webpack_public_path__ + "static/media/chettinad.d94b456f.png";